<template>
  <input :id="id" />
</template>

<script>
  let vm = {
    name: 'input-data-format',
    props: {
      id: String,
      name: String,
      className: String,
      value: [String, Number],
      classes: {
        type: Object,
        default: () => ({
          wrapper: false,
          input: false,
          list: false,
          item: false
        })
      },
      placeholder: String,
      required: Boolean,
      // Intial Value
      // initValue: {
      //   type: String,
      //   default: ''
      // },
      // Manual List
      // options: Array,
      // Filter After Get the data
      filterByAnchor: {
        type: Boolean,
        default: true
      },
      // Anchor of list
      anchor: {
        type: String,
        required: false
      },
      // Label of list
      label: String,
      // Debounce time
      debounce: Number,
      // ajax URL will be fetched
      url: {
        type: String,
        required: false
      },
      // query param
      param: {
        type: String,
        default: 'q'
      },
      encodeParams: {
        type: Boolean,
        default: true
      },
      // Custom Params
      customParams: Object,
      // Custom Headers
      customHeaders: Object,
      // minimum length
      min: {
        type: Number,
        default: 0
      },
      // Create a custom template from data.
      onShouldRenderChild: Function,
      // Process the result before retrieveng the result array.
      process: Function,
      // Callback
      onInput: Function,
      onShow: Function,
      onBlur: Function,
      onHide: Function,
      onFocus: Function,
      onSelect: Function,
      onBeforeAjax: Function,
      onAjaxProgress: Function,
      onAjaxLoaded: Function,
      onShouldGetData: Function
    },
    mounted () {
      // var vmm = this
      $(this.$el).mask('99/99/9999')
      $(this.$el).val(this.value)
      // $(this.$el).on('change', function () {
      //   vmm.$emit('input', this.value)
      // })
    },
    watch: {
      value: function (value) {
        // update value
        $(this.$el).val(value)
        $(this.$el).mask('99/99/9999')
        $(this.$el).trigger('paste')
        $(this.$el).trigger('input')

        $(this.$el).find('#' + this.id).val(value)
        // this.setValue(value)
      }
    },
    methods: {
      setValue (date) {
        $(this.$el).val(date)
        // $(this.$el).find('#' + this.id).val(date)
      },
      setDataFinal () {
        $(this.$el).find('#dataFinal').val(this.value)
      }
    }
    // handleBlur (e) {
    //   // Callback Event
    //   if (this.onBlur) {
    //     this.onBlur(e)
    //   }
    // }
  }
  module.exports = vm
  // let vm = {
  //   name: 'input-data-picker',
  //   props: {
  //     id: String,
  //     value: {
  //       validator: function (val) {
  //         return val === null || val instanceof Date || typeof val === 'string'
  //       }
  //     },
  //     format: {
  //       default: 'dd/mm/yy'
  //     }
  //   },
  //   watch: {
  //     value (value) {
  //       console.log('#' + this.id)
  //       $(this.$el).find('#' + this.id).val(value)
  //       this.setValue(value)
  //     },
  //     openDate () {
  //       this.setPageDate()
  //     },
  //     initialView () {
  //       this.setInitialView()
  //     }
  //   },
  //   methods: {
  //     setValue (date) {
  //       console.log('set value')
  //       $(this.$el).val(date)
  //       // $(this.$el).find('#' + this.id).val(date)
  //     },
  //     setarData: function () {
  //     }
  //   },
  //   mounted () {
  //     var vmm = this
  //     $(this.$el).datepicker({
  //       closeText: 'Fechar',
  //       prevText: '&#x3c;Anterior',
  //       nextText: 'Pr&oacute;ximo&#x3e;',
  //       currentText: 'Hoje',
  //       monthNames: ['Janeiro', 'Fevereiro', 'Mar&ccedil;o', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  //       monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  //       dayNames: ['Domingo', 'Segunda-feira', 'Ter&ccedil;a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sabado'],
  //       dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  //       dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  //       weekHeader: 'Sm',
  //       dateFormat: 'dd/mm/yy',
  //       firstDay: 0,
  //       isRTL: false,
  //       showMonthAfterYear: false,
  //       yearSuffix: '',
  //       onSelect: function (date) {
  //         vmm.$emit('input', date)
  //       }
  //     })
  //     $(this.$el).val(this.value)
  //     // $(this.$el).find('#' + this.id).val(this.value)
  //     $(this.$el).on('change', function () {
  //       console.log('mount')
  //       vmm.$emit('input', this.value)
  //     })
  //   }
  // }
  // module.exports = vm
</script>
};


// WEBPACK FOOTER //
// src/components/spark-components/spark-scrollbar/SparkInputDataFormat.vue